var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-subheader', [_vm._v(_vm._s(_vm.$t("objects.contract.customer.general")))]), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.customer.minimumTermInMonths'),
      "hint": _vm.$t('objects.contract.customer.minimumTermInMonthsHint'),
      "persistent-hint": "",
      "type": "number",
      "readonly": !_vm.isEditing,
      "outlined": "",
      "clearable": _vm.isEditing,
      "rules": _vm.greaterThanZeroRule
    },
    on: {
      "input": function input($event) {
        return _vm.onFieldChanged('objects.contract.customer.minimumTermInMonths');
      }
    },
    model: {
      value: _vm.localDetails.minimumTermInMonthsFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.localDetails, "minimumTermInMonthsFormable", _vm._n($$v));
      },
      expression: "localDetails.minimumTermInMonthsFormable"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.customer.cancellationNoticePeriod'),
      "hint": _vm.$t('objects.contract.customer.cancellationNoticePeriodHint'),
      "persistent-hint": "",
      "readonly": !_vm.isEditing,
      "outlined": "",
      "clearable": _vm.isEditing
    },
    on: {
      "input": function input($event) {
        return _vm.onFieldChanged('objects.contract.customer.cancellationNoticePeriod');
      }
    },
    model: {
      value: _vm.localDetails.cancellationNoticePeriod,
      callback: function callback($$v) {
        _vm.$set(_vm.localDetails, "cancellationNoticePeriod", $$v);
      },
      expression: "localDetails.cancellationNoticePeriod"
    }
  }), _c('v-subheader', [_vm._v(_vm._s(_vm.$t("objects.contract.customer.billing")))]), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.customer.breakdownFeePerCase'),
      "hint": _vm.$t('objects.contract.customer.breakdownFeePerCaseHint'),
      "persistent-hint": "",
      "type": "number",
      "readonly": !_vm.isEditing,
      "outlined": "",
      "clearable": _vm.isEditing,
      "rules": _vm.greaterThanZeroRule
    },
    on: {
      "input": function input($event) {
        return _vm.onFieldChanged('objects.contract.customer.breakdownFeePerCase');
      }
    },
    model: {
      value: _vm.localDetails.breakdownFeePerCaseFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.localDetails, "breakdownFeePerCaseFormable", _vm._n($$v));
      },
      expression: "localDetails.breakdownFeePerCaseFormable"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.customer.accidentFeePerCase'),
      "hint": _vm.$t('objects.contract.customer.accidentFeePerCaseHint'),
      "persistent-hint": "",
      "type": "number",
      "readonly": !_vm.isEditing,
      "outlined": "",
      "clearable": _vm.isEditing,
      "rules": _vm.greaterThanZeroRule
    },
    on: {
      "input": function input($event) {
        return _vm.onFieldChanged('objects.contract.customer.accidentFeePerCase');
      }
    },
    model: {
      value: _vm.localDetails.accidentFeePerCaseFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.localDetails, "accidentFeePerCaseFormable", _vm._n($$v));
      },
      expression: "localDetails.accidentFeePerCaseFormable"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.customer.managementFeePerVehicleMonthly'),
      "hint": _vm.$t('objects.contract.customer.managementFeePerVehicleMonthlyHint'),
      "persistent-hint": "",
      "type": "number",
      "readonly": !_vm.isEditing,
      "outlined": "",
      "clearable": _vm.isEditing,
      "rules": _vm.greaterThanZeroRule
    },
    on: {
      "input": function input($event) {
        return _vm.onFieldChanged('objects.contract.customer.managementFeePerVehicleMonthly');
      }
    },
    model: {
      value: _vm.localDetails.managementFeePerVehicleMonthlyFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.localDetails, "managementFeePerVehicleMonthlyFormable", _vm._n($$v));
      },
      expression: "localDetails.managementFeePerVehicleMonthlyFormable"
    }
  }), _c('v-subheader', [_vm._v(_vm._s(_vm.$t("objects.contract.customer.approvals")))]), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.customer.comprehensiveRepairApprovalLimit'),
      "hint": _vm.$t('objects.contract.customer.comprehensiveRepairApprovalLimitHint'),
      "persistent-hint": "",
      "type": "number",
      "readonly": !_vm.isEditing,
      "outlined": "",
      "clearable": _vm.isEditing,
      "rules": _vm.greaterThanZeroRule
    },
    on: {
      "input": function input($event) {
        return _vm.onFieldChanged('objects.contract.customer.comprehensiveRepairApprovalLimit');
      }
    },
    model: {
      value: _vm.localDetails.comprehensiveRepairApprovalLimitFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.localDetails, "comprehensiveRepairApprovalLimitFormable", _vm._n($$v));
      },
      expression: "localDetails.comprehensiveRepairApprovalLimitFormable"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.customer.liabilityRepairApprovalLimit'),
      "hint": _vm.$t('objects.contract.customer.liabilityRepairApprovalLimitHint'),
      "persistent-hint": "",
      "type": "number",
      "readonly": !_vm.isEditing,
      "outlined": "",
      "clearable": _vm.isEditing,
      "rules": _vm.greaterThanZeroRule
    },
    on: {
      "input": function input($event) {
        return _vm.onFieldChanged('objects.contract.customer.liabilityRepairApprovalLimit');
      }
    },
    model: {
      value: _vm.localDetails.liabilityRepairApprovalLimitFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.localDetails, "liabilityRepairApprovalLimitFormable", _vm._n($$v));
      },
      expression: "localDetails.liabilityRepairApprovalLimitFormable"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.customer.purchaseVehicleRepairApprovalLimit'),
      "hint": _vm.$t('objects.contract.customer.purchaseVehicleRepairApprovalLimitHint'),
      "persistent-hint": "",
      "type": "number",
      "readonly": !_vm.isEditing,
      "outlined": "",
      "clearable": _vm.isEditing,
      "rules": _vm.greaterThanZeroRule
    },
    on: {
      "input": function input($event) {
        return _vm.onFieldChanged('objects.contract.customer.purchaseVehicleRepairApprovalLimit');
      }
    },
    model: {
      value: _vm.localDetails.purchaseVehicleRepairApprovalLimitFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.localDetails, "purchaseVehicleRepairApprovalLimitFormable", _vm._n($$v));
      },
      expression: "localDetails.purchaseVehicleRepairApprovalLimitFormable"
    }
  }), _c('v-subheader', [_vm._v(_vm._s(_vm.$t("objects.contract.customer.rental")))]), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.customer.comprehensiveRentalCarDefault'),
      "hint": _vm.$t('objects.contract.customer.comprehensiveRentalCarDefaultHint'),
      "persistent-hint": "",
      "readonly": !_vm.isEditing,
      "outlined": "",
      "clearable": _vm.isEditing
    },
    on: {
      "input": function input($event) {
        return _vm.onFieldChanged('objects.contract.customer.comprehensiveRentalCarDefault');
      }
    },
    model: {
      value: _vm.localDetails.comprehensiveRentalCarDefault,
      callback: function callback($$v) {
        _vm.$set(_vm.localDetails, "comprehensiveRentalCarDefault", $$v);
      },
      expression: "localDetails.comprehensiveRentalCarDefault"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.customer.rentalCarVIPDefault'),
      "hint": _vm.$t('objects.contract.customer.rentalCarVIPDefaultHint'),
      "persistent-hint": "",
      "readonly": !_vm.isEditing,
      "outlined": "",
      "clearable": _vm.isEditing
    },
    on: {
      "input": function input($event) {
        return _vm.onFieldChanged('objects.contract.customer.rentalCarVIPDefault');
      }
    },
    model: {
      value: _vm.localDetails.rentalCarVIPDefault,
      callback: function callback($$v) {
        _vm.$set(_vm.localDetails, "rentalCarVIPDefault", $$v);
      },
      expression: "localDetails.rentalCarVIPDefault"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.customer.rentalCarThirdPartyDamageDefault'),
      "hint": _vm.$t('objects.contract.customer.rentalCarThirdPartyDamageDefaultHint'),
      "persistent-hint": "",
      "readonly": !_vm.isEditing,
      "outlined": "",
      "clearable": _vm.isEditing
    },
    on: {
      "input": function input($event) {
        return _vm.onFieldChanged('objects.contract.customer.rentalCarThirdPartyDamageDefault');
      }
    },
    model: {
      value: _vm.localDetails.rentalCarThirdPartyDamageDefault,
      callback: function callback($$v) {
        _vm.$set(_vm.localDetails, "rentalCarThirdPartyDamageDefault", $$v);
      },
      expression: "localDetails.rentalCarThirdPartyDamageDefault"
    }
  }), _c('v-subheader', [_vm._v(_vm._s(_vm.$t("objects.contract.customer.other")))]), _c('custom-field-boolean', {
    attrs: {
      "disabled": !_vm.isEditing,
      "customField": {
        label: _vm.$t('objects.contract.customer.isWrappingIncluded'),
        hint: _vm.$t('objects.contract.customer.isWrappingIncludedHint')
      }
    },
    on: {
      "input": function input($event) {
        return _vm.onFieldChanged('objects.contract.customer.isWrappingIncluded');
      }
    },
    model: {
      value: _vm.localDetails.isWrappingIncluded,
      callback: function callback($$v) {
        _vm.$set(_vm.localDetails, "isWrappingIncluded", $$v);
      },
      expression: "localDetails.isWrappingIncluded"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }